<html lang="en">

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
  <meta name="description" content="Webtest Login">
  <meta name="author" content="Web Test">
  <title>WEB TEST</title>
  <!-- Favicon -->
  <link rel="icon" type="image/png" sizes="32x32" href="../../assets/images/favicon-32x32.png"/>
  <!-- Fonts -->
  <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700"/>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet"/>
 
  <!-- Argon CSS -->
  <link rel="stylesheet" href="/assets/css/argon.css?v=1.2.0" type="text/css"/>
  <style type="text/css">
    body {
      background-color: #e9f3fc !important;
    }

    .navbar-horizontal.navbar-transparent {
      position: relative;
    }

    .form-control-label {
      font-size: 14px !important;
    }
  </style>
</head>

<body style="background-color: #e9f3fc"> <!-- remove bg-default class and height: 100vh;-->
  <!-- Main content -->
  <div class="main-content" role="main">
    <div class="container-fluid">
      <div class="end-lang">
        <app-language-layout></app-language-layout>
      </div>

      <div class="row">
        <div class="col-sm-12 webtest-logo">
          <a href="/" [attr.aria-label]="language.webTestLogo"><img src="/assets/images/main-logo.png" [alt]="language.webTestLogo"/></a>
        </div>
        <div class="col-sm-12 mobile-logo">
          <a href="/"  [attr.aria-label]="language.webTestLogo"><img src="/assets/images/main-logo-block.png" width="105" [alt]="language.webTestLogo"/></a>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container"><!--remove mt--8 pb-5 -->
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- Argon Scripts -->
  <!-- Core -->
  <script src="../../assets/vendor/jquery/dist/jquery.min.js"></script>
  <script src="../../assets/vendor/bootstrap/dist/js/bootstrap.bundle.min.js"></script>
  <script src="../../assets/vendor/js-cookie/js.cookie.js"></script>
  <script src="../../assets/vendor/jquery.scrollbar/jquery.scrollbar.min.js"></script>
  <script src="../../assets/vendor/jquery-scroll-lock/dist/jquery-scrollLock.min.js"></script>
  <!-- Argon JS -->
  <script src="../../assets/js/argon.js?v=1.2.0"></script>
  <!-- Demo JS - remove this in your project -->
  <script src="../../assets/js/demo.min.js"></script>

  <!-- fill the entire browser with loginbg -->

</body>

</html>